/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

/* eslint camelcase: [0] */

import CredentialsConfig from './credentials-config';
import {MemoryStoreAdapter} from './lib/storage';


export default {
  maxAppLevelRedirects: 10,
  maxLocusRedirects: 5,
  maxAuthenticationReplays: 1,
  maxReconnectAttempts: 1,
  onBeforeLogout: [],
  trackingIdPrefix: 'spark-js-sdk',
  trackingIdSuffix: '',
  AlternateLogger: undefined,
  credentials: new CredentialsConfig(),
  device: {
    preDiscoveryServices: {
      hydra: process.env.HYDRA_SERVICE_URL || 'https://api.ciscospark.com/v1',
      hydraServiceUrl: process.env.HYDRA_SERVICE_URL || 'https://api.ciscospark.com/v1'
    },
    validateDomains: process.env.VALIDATE_DOMAINS === 'true' || false,
    // It is okay to pass the auth token to the following domains:
    whitelistedServiceDomains: [
      'webexkubed.com',
      'wbx3.com',
      'wbx2.com',
      'ciscospark.com',
      'webex.com'
    ]
  },
  payloadTransformer: {
    predicates: [],
    transforms: []
  },
  storage: {
    boundedAdapter: MemoryStoreAdapter,
    unboundedAdapter: MemoryStoreAdapter
  }
};
